/**
 * TwitterのWeb Intent URLを生成する
 */
export const createTwitterShareUrl = (text: string, url: string): string => {
  const tweetText = `${text}\n`;
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}&url=${encodeURIComponent(url)}`;
};
